<div class="cookie-policy-container view">
    <div class="title">{{ 'cookie-policy.title' | transloco }}</div>
    <div class="cookie-policy-container__content">
        <div class="cookie-policy-container__content__text left">
            <span>{{ 'cookie-policy.paragraph-0' | transloco }}</span>
            <h4>{{ 'cookie-policy.paragraph-header-1' | transloco }}</h4>
            <span>{{ 'cookie-policy.paragraph-1' | transloco }}</span>
            <h4>{{ 'cookie-policy.paragraph-header-2' | transloco }}</h4>
            <ul>
                <li>{{ 'cookie-policy.paragraph-2-ul.1' | transloco }}</li>
                <li>{{ 'cookie-policy.paragraph-2-ul.2' | transloco }}</li>
                <li>{{ 'cookie-policy.paragraph-2-ul.3' | transloco }}</li>
                <li>{{ 'cookie-policy.paragraph-2-ul.4' | transloco }}</li>
                <li>{{ 'cookie-policy.paragraph-2-ul.5' | transloco }}</li>
            </ul>
        </div>
        <div class="cookie-policy-container__content__right">
            <div class="cookie-policy-container__content__right__content">
                <div class="cookie-policy-container__content__right__img still-life-1"></div>
                <div class="cookie-policy-container__content__right__decorator"></div>
            </div>
        </div>
    </div>
    <div class="cookie-policy-container__content">
        <div class="cookie-policy-container__content__right">
            <div class="cookie-policy-container__content__right__content">
                <div class="cookie-policy-container__content__right__img still-life-2"></div>
                <div class="cookie-policy-container__content__right__decorator"></div>
            </div>
        </div>
        <div class="cookie-policy-container__content__text right">
            <h4 class="initial">{{ 'cookie-policy.paragraph-header-3' | transloco }}</h4>
            <span>{{ 'cookie-policy.paragraph-3' | transloco }}</span>
            <h4 ><li>{{ 'cookie-policy.paragraph-header-4' | transloco }}</li></h4>
            <span>{{ 'cookie-policy.paragraph-4' | transloco }}</span>
            <div class="cookie-section">
                <div class="cookie-section__info">
                    <span class="header">{{ 'cookie-policy.cookie-type-header' | transloco }}</span>
                    <span>{{ 'cookie-policy.cookie-type-text' | transloco }}</span>
                </div>
                <div class="cookie-section__info">
                    <span class="header">{{ 'cookie-policy.cookie-expiration-header' | transloco }}</span>
                    <span>{{ 'cookie-policy.cookie-expiration-text' | transloco }}</span>
                </div>
                <div class="cookie-section__info last">
                    <span class="header">{{ 'cookie-policy.cookie-function-header' | transloco }}</span>
                    <span>{{ 'cookie-policy.cookie-function-text' | transloco }}</span>
                </div>
            </div>            
            <h4 ><li>{{ 'cookie-policy.paragraph-header-5' | transloco }}</li></h4>
            <span>{{ 'cookie-policy.paragraph-5' | transloco }}</span>
            <h4 ><li>{{ 'cookie-policy.paragraph-header-6' | transloco }}</li></h4>
            <span>{{ 'cookie-policy.paragraph-6' | transloco }}</span>
            
            <ul>
                <li [innerHTML]="'cookie-policy.paragraph-6-ul.1' | transloco"></li>
                <li [innerHTML]="'cookie-policy.paragraph-6-ul.2' | transloco"></li>
                <li [innerHTML]="'cookie-policy.paragraph-6-ul.3' | transloco"></li>
            </ul>
        </div>
    </div>
</div>

